import React from "react";

import PaymentRequestManager from "../models/client_payments_model/PaymentRequestManager";

import DynamicTable from "../../../../components/reusable/DynamicTable";
import LoadingSpinner from "../../../../components/loaders/LoadingSpinner";
import BaseIcon from "../../../../components/svg_icons/BaseIcon";

const AllClientPaymentsRequestsPage = () => {
    return (
        <PaymentRequestManager
            loadOverview={false}
            loadPlatformOverview={false}
            loadRequests={true}
        >
            {({
                paymentRequests,
                loadingPaymentRequests,
                openExisting,
                deletePaymentRequest,
            }) => {
                const requestsColumn = [
                    { key: "__sn", label: "Sr. No.", sortable: false },
                    { key: "client_name", label: "Client", sortable: true },
                    { key: "title", label: "Request Title", sortable: true },
                    {
                        key: "amount", label: "Amount", sortable: true,
                        render: (value, row) =>
                            `${row.currency || "INR"} ${value}`,
                    },
                    { key: "status", label: "Status", sortable: true },
                    {
                        key: "due_date", label: "Due Date", sortable: true,
                        render: (value) =>
                            value
                                ? new Date(value).toLocaleDateString("en-IN")
                                : "-",
                    },
                ];

                const actions = [
                    {
                        icon: <BaseIcon name="eyeOpen" size={20} />,
                        title: "View",
                        onClick: (row) => { openExisting(row); },
                    },
                    {
                        icon: <BaseIcon name="trash" size={20} />,
                        title: "Delete",
                        className: "delete",
                        onClick: (row) => { deletePaymentRequest(row); },
                    },
                ];

                if (loadingPaymentRequests) {
                    return <LoadingSpinner />;
                }

                return (
                    <DynamicTable
                        columns={requestsColumn}
                        data={paymentRequests}
                        onAction={actions}
                    />
                );
            }}
        </PaymentRequestManager>
    );
};

export default AllClientPaymentsRequestsPage;
